import { Injectable } from '@angular/core';
import {
  ICompaniesShortList,
  IParkerCompanyList,
  IParkerActiveListForInvoiceGeneration,
} from 'src/app/shared/interfaces';
import { DataService } from 'src/app/core/services/data/data.service';
import { firstValueFrom } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class spaceArCoreHttpApi {
  constructor(private dataService: DataService) {}

  getCompanyList(lotNumber: string): Observable<ICompaniesShortList[]> {
    return this.dataService.getCompanyListForLotNumber(lotNumber);
  }

  getParkerShortListByCompanyId(companyId: string): Observable<IParkerCompanyList[]> {
    return this.dataService.GetParkerListForCompany(companyId);
  }

  /// This is used to get the list of parkers for a company that is designated as active within a date range for invoice generation.
  getActiveFutureParkerListByCompanyId(
    companyId: string,
    startDate: Date,
    endDate: Date,
  ): Observable<IParkerActiveListForInvoiceGeneration[]> {
    return this.dataService.getActiveParkerListByCompanyIdForFutureMonths(companyId, startDate, endDate);
  }

  /// This is used to get the list of parkers for a company that is designated as active within a date range for invoice generation.
  getActivePastParkerListByCompanyId(
    companyId: string,
    startDate: Date,
    endDate: Date,
  ): Observable<IParkerActiveListForInvoiceGeneration[]> {
    return this.dataService.getActiveParkerListByCompanyIdForPastMonths(companyId, startDate, endDate);
  }

  /// Gets the status of whether invoice line item description customization is enabled
  /// or not for a given lot number. This is used to determine whether to show the
  /// invoice line item description input field.
  getInvoiceLineDescriptionCustomizationStatus(lotNumber: string): Observable<boolean> {
    return this.dataService.GetGbInvoiceLineItemDescriptionStatusForLotNumber(lotNumber);
  }
}
